import { NgModule } from '@angular/core'
import { CommonModule } from '@angular/common'
import { ContentSearchResultComponent } from './content-search-result.component'
import { SharedModule } from '../shared/shared.module'
import { CardComponent } from './card/card.component'



@NgModule({
  declarations: [ContentSearchResultComponent, CardComponent],
  imports: [
    CommonModule,
    SharedModule
  ],
  exports: [ContentSearchResultComponent]
})
export class ContentSearchResultModule { }
